
<template>
    <v-container style="background-color: #23262d;" fluid>
        <template>
			<v-row>
				<v-row>
					<v-card
						class="mx-auto"
						:loading="loading"
						max-width="270"
					>
						
						<v-card-text>
							<p style="font-size:25px" class="text--primary">
								Master Control
							</p>
							<v-expansion-panels multiple focusable accordion>
								<v-expansion-panel>
								<v-expansion-panel-header>
									Filtro por Sucursal {{selectedLocalidad}}
								</v-expansion-panel-header>

								<v-expansion-panel-content >
									<!-- Contenido que se mostrará cuando se expanda el panel -->
									<div class="mx-1">  
										<v-radio-group >
											<v-radio label="Todas" :value="null" @change="LimpiarSucursal()"> </v-radio>
											<v-radio @change="toggleSelectedLocalidad(x)" v-for="(x, index) in Localidades" :key="index" :label="x" :value="x"></v-radio>
										</v-radio-group>
									</div>
									<!-- Puedes agregar más contenido aquí -->
								</v-expansion-panel-content>
								</v-expansion-panel>
								<v-expansion-panel>
								<v-expansion-panel-header>
									Filtro por Estado
								</v-expansion-panel-header>

								<v-expansion-panel-content >
									<!-- Contenido que se mostrará cuando se expanda el panel -->
									<v-radio-group >
										<v-radio label="Todos" :value="null" @change="LimpiarEstado()"> </v-radio>
										<v-radio :color="getColor(x.value)" @change="toggleSelectedEstado(x.value)" v-for="(x, index) in Estados" :key="index" :label="x.text" :value="x.value"></v-radio>
									</v-radio-group>
									<!-- Puedes agregar más contenido aquí -->
								</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</v-card-text>
					</v-card>
					<v-card :style="{ height: 'auto' }" class="mx-auto justify-center align-center" width="270" flat v-for="(item , index) in usuarios" :key="index">


							<v-toolbar dark :color="getColorLocalidad(item.localidad)"> 
								<div >Orden {{item.noFactura}} </div> <v-spacer />
								<v-chip  color="#2797ce" >{{orderTimes[item.noFactura]}}</v-chip>
							</v-toolbar>
								<v-row class="mb-2 mx-2">
									<v-edit-dialog
										:return-value.sync="item.estado"
										@save="updateOrdenExpress(item)"
										large
										persistent
									>
										<v-chip class="mt-2 white--text" :color="getColor(item.estado)" style="font-size:20px">  {{EstadoNombre(item.estado)}}</v-chip>
										<template v-slot:input>
											<v-select
												v-model="item.estado"
												label="Seleccione El estado:"
												:items="Estados"
											></v-select>
										</template>
									</v-edit-dialog>
									<v-radio readonly color="green" v-model="item.facturacion"  />
								</v-row>
									<v-edit-dialog
										:return-value.sync="item.localidad"
										@save="updateOrdenExpress(item)"
										large
										persistent
									>
										<b style="font-size:15px"> Sucursal: {{item.localidad}} </b>
										<template v-slot:input>
											<v-select
												v-model="item.localidad"
												label="Seleccione la sucursal para asginar:"
												:items="Localidades"
											></v-select>
										</template>
									</v-edit-dialog>
									<v-edit-dialog
										:return-value.sync="item.tipoCompra"
										@save="updateOrdenExpress(item)"
										large
										persistent
									>
										<b> Entrega:{{item.tipoCompra}} </b>
										<template v-slot:input>
											<v-select
												v-model="item.tipoCompra"
												label="Seleccione el método de entrega:"
												:items="MetodosEntrega"
											></v-select>
										</template>
									</v-edit-dialog>
									
								<p class="mx-1" style="font-size:15px; color: secondary;"> 
									<v-edit-dialog
										:return-value.sync="item.nombre"
										@save="updateOrdenExpress(item)"
									>
										<b>Cliente: </b>{{item.nombre}}
										<template v-slot:input>
											<v-text-field
												onfocus="this.select();"
												v-model="item.nombre"
												:rules="[max25chars]"
												label="Nombre del cliente:"
											></v-text-field>
										</template>
									</v-edit-dialog>
									
									<v-edit-dialog
										:return-value.sync="item.telefono"
										@save="updateOrdenExpress(item)"
									>
										<b> Teléfono </b> {{item.telefono}}
										<template v-slot:input>
											<v-text-field
												onfocus="this.select();"
												v-model="item.telefono"
												:rules="[max25chars]"
												label="Teléfono:"
											></v-text-field>
										</template>
									</v-edit-dialog>
									
									
									<v-edit-dialog
										:return-value.sync="item.nota"
										@save="updateOrdenExpress(item)"
										large
										persistent
									>
									<b>	Nota: </b> {{item.nota}} 
										<template v-slot:input>
											<v-textarea onfocus="this.select();"
												v-model="item.nota"
												:rules="[max25chars]"
												label="Nota:"/>
										</template>
									</v-edit-dialog> 
									<br>
									<b style="font-size:20px">₡{{item.total}} </b>
									
								</p>
							<v-expansion-panels multiple popout accordion>
								<v-expansion-panel>
								<v-expansion-panel-header>
									Ver más
								</v-expansion-panel-header>

								<v-expansion-panel-content >
									<!-- Contenido que se mostrará cuando se expanda el panel -->
									<v-simple-table dense>
										<template v-slot:default>
										<thead>
											<tr>
											<th class="text-left">
												Item
											</th>
											<th class="text-left">
												Precio
											</th>
											</tr>
										</thead>
										<tbody>
											<tr
											v-for="x in item.detalles"
											:key="x.name"
											>
											
											<td style="font-size:12px;">{{x.descripcion}} <b>x{{x.cantidad}}</b></td>
											<td style="font-size:12px;">
												<div v-if="x.descuento != 0">
													<s>{{x.precio * x.cantidad}} </s>
													{{calcularPrecioPromos(x)}}	
												</div>
												<div v-else>
													{{x.precio * x.cantidad}}
												</div>
												
											</td>
											</tr>
										</tbody>
										
										</template>
									</v-simple-table>
									Guía {{item.orden}} 
									
									<v-edit-dialog
										:return-value.sync="item.direccion"
										@save="updateOrdenExpress(item)"
										large
										persistent
									>
										<b> Dirección: </b> {{item.direccion}}   {{item.latitud}}   {{item.longitud}}  
										<template v-slot:input>
											<v-textarea onfocus="this.select();"
												v-model="item.direccion"
												:rules="[max25chars]"
												label="Direccion:"/>
										</template>
									</v-edit-dialog> 
									
									<b> Nota del Mensajero: </b>{{item.detalle}} 
									<v-edit-dialog
										:return-value.sync="item.medioOrden"
										@save="updateOrdenExpress(item)"
									>
										Medio {{item.medioOrden}} 
										<template v-slot:input>
											<v-text-field
												onfocus="this.select();"
												v-model="item.medioOrden"
												:rules="[max25chars]"
												label="Tomado por medio de:"
											></v-text-field>
										</template>
									</v-edit-dialog>
									<v-edit-dialog
										:return-value.sync="item.tipoPago1"
										@save="updateOrdenExpress(item)"
									>
										<b> Tipo Pago: </b>{{ item.tipoPago1 }}
										<template v-slot:input>
											<v-text-field
												onfocus="this.select();"
												v-model="item.tipoPago1"
												:rules="[max25chars]"
												label="Tipo de pago:"
											></v-text-field>
										</template>
									</v-edit-dialog>
									<v-edit-dialog
										:return-value.sync="item.mensajero"
										@save="updateOrdenExpress(item)"
									>
										<b> Mensajero: </b> {{item.mensajero}} 
										<template v-slot:input>
											<v-text-field
												onfocus="this.select();"
												v-model="item.mensajero"
												:rules="[max25chars]"
												label="Mensajero:"
											></v-text-field>
										</template>
									</v-edit-dialog>
									<v-edit-dialog
										:return-value.sync="item.cajero"
										@save="updateOrdenExpress(item)"
									>
										<b>Agente: </b> {{item.cajero}} 
										<template v-slot:input>
											<v-text-field
												onfocus="this.select();"
												v-model="item.cajero"
												:rules="[max25chars]"
												label="Agente:"
											></v-text-field>
										</template>
									</v-edit-dialog>
									<v-edit-dialog
										:return-value.sync="item.cedula"
										@save="updateOrdenExpress(item)"
									>
										Cédula {{item.cedula}} {{item.tipoCedula}} 
										<template v-slot:input>
											<v-text-field
												onfocus="this.select();"
												v-model="item.cedula"
												:rules="[max25chars]"
												label="Cedula:"
											></v-text-field>
										</template>
									</v-edit-dialog>
									
									<!-- Puedes agregar más contenido aquí -->
								</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
							<v-card-actions>
								<v-btn
									v-if="item.estado == 0"
									color="green"
									outlined
									block
									@click="actualizarEstado(item,1)"
								>
									Enviar
								</v-btn>
							</v-card-actions>
					</v-card>
				</v-row>
			</v-row>
        </template>
    </v-container>
</template>
<script>

import axios from 'axios'
  export default {
    data: () => ({
		MetodosEntrega: ["Envio Propio","Retira en sucursal","Correos de CR","Otro"],
        usuarios:[],    
		Localidades:[],
		Estados:[{text:"En Central",value:"0"},{text:"Esperando Sucursal",value:"1"},
		{text:"En Sucursal",value:"2"},{text:"En Ruta",value:"3"},{text:"Entregado",value:"4"}
		,{text:"Cancelado",value:"5"},{text:"No se pudo entregar",value:"6"}],
		multiplo:10,
        editedIndex: -1,
		loading: true,
		selectedLocalidad:null,
		selectedEstado:null,
		keySequence: '', // Aquí almacenaremos las teclas presionadas.
		orderTimes: {},
		timeUpdateInterval:null,
		prevUsersLength: 0, // Añadir esta propiedad para almacenar la longitud anterior de 'usuarios'
      	sound: new Audio(require('@../../../assets/pageAssets/inbox.mp3'))
    }),
	mounted() {
		
		document.addEventListener('keyup', this.handleKeyUp);
		 // Establece un intervalo para actualizar el tiempo transcurrido cada segundo
    	this.timeUpdateInterval = setInterval(this.updateOrderTimes, 1000);
		this.enterFullscreen();
		// Obtener el elemento <v-col> por su ID
		var colElement = document.getElementById('columnadetalles');

		// Obtener la altura de la pantalla
		var screenHeight = window.innerHeight;

		// Establecer la altura del elemento al valor de la altura de la pantalla
		colElement.style.height = screenHeight + 'px';
	},
	beforeDestroy() {
		document.removeEventListener('keyup', this.handleKeyUp);
		clearInterval(this.timeUpdateInterval);  // Limpia el intervalo
	},
    created () {
	  this.listarAsociadas();
      this.listar();
    },

    methods: {
		async listarAsociadas(){
			var items = [];
			let me=this;
			me.Localidades.push(me.$store.state.usuario.localidad);
			this.localidad = this.$store.state.usuario.localidad;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.get('api/LocalidadesAsociadas/'+this.$store.state.usuario.nombre,configuracion).then(function(response){
				items=response.data;
				items.map(function(x){
					me.Localidades.push(x.localdiadAsociada);
				});
			}).catch(function(error){
				alert("Producto no encontrado");
				me.modelCarga=false;
			});
		},
		async actualizarEstado(item,estado) {
			this.loading = true;
			try {
				const response = await axios.put('/api/OrdenExpress/ActualizarEstado', {
				NoFactura: item.noFactura,
				Estado: estado,
				Mensajero: item.mensajero,
				});

				console.log(response.data); // Si deseas ver la respuesta en la consola

				// Manejar la respuesta, por ejemplo mostrar un mensaje de éxito
				item.estado = estado;
				this.loading = false;

			} catch (error) {
				console.error("Hubo un error al actualizar el estado:", error);
				// Manejar el error, por ejemplo mostrar un mensaje de error
				this.loading = false;
				alert("Error al actualizar el estado.");
			}
		},
		calcularPrecioPromos(data) {
			var resultado = 0.0;
			var montoDescuento;
			// Calcular el descuento
			montoDescuento = (data.precio * data.cantidad) - ((data.descuento) / 100) * (data.precio * data.cantidad);
			resultado = Math.ceil(montoDescuento / this.multiplo) * this.multiplo;
			return resultado;
		},
		handleKeyUp(event) {
			// Si el usuario presiona un número (sobre las letras o en el numpad).
			if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
				// Para manejar tanto el teclado normal como el numpad
				let key = (event.keyCode >= 96 && event.keyCode <= 105) ? String.fromCharCode(event.keyCode - 48) : event.key;
				this.keySequence += key;
			} 
			// Si el usuario presiona Enter.
			else if (event.keyCode == 13) {
				// Convertir la secuencia a número y verificar que está en el rango correcto.
				let orderNumber = parseInt(this.keySequence.trim());
				if (orderNumber >= 0 && orderNumber <= 100) {
				this.deleteOrden(orderNumber);
				}
				// Limpiar la secuencia de teclas.
				this.keySequence = '';
			} 
			// Si se presiona una tecla que no es número ni Enter.
			else {
				this.keySequence = '';
			}
		},
		calculateTimeElapsed(Hora) {
			var now = new Date();
			var hor1 = now.getHours();
			var min1 = now.getMinutes();
			var sec1 = now.getSeconds();

			var hor2 = parseInt(Hora.substring(0, 2));
			var min2 = parseInt(Hora.substring(3, 5));

			var diffInSec = (hor1 * 3600 + min1 * 60 + sec1) - (hor2 * 3600 + min2 * 60);

			// Si la diferencia es negativa, sumamos 24 horas (en segundos) para ajustar el cálculo
			if (diffInSec < 0) diffInSec += 24 * 3600;

			var hours = Math.floor(diffInSec / 3600);
			diffInSec %= 3600;
			var minutes = Math.floor(diffInSec / 60);
			var seconds = diffInSec % 60;

			return hours + "h: " + minutes + "m: " + seconds + "s";
		},
		getColorLocalidad (estado) {
			if (estado == "King Vape Escazu") return "#ff007f";
			else if (estado == "King Vape Zapote") return "#FF5733";
			else if (estado == "King Vape Heredia") return "#40e0d0";
			else if (estado == 'King Vape Cartago') return '#b3c100'
			else if (estado == '4') return 'indigo' 
			else  return 'red'
		},
		getColor (estado) {
			if (estado == '0') return '#23262d'
			else 
			if (estado == '1') return 'error'
			else 
			if (estado == '2') return 'orange'
			else 
			if (estado == '3') return 'green'
			else 
			if (estado == '4') return 'indigo'
			
			else  return 'red'
		},
		EstadoNombre (estado) {
			if (estado == '0') return 'En Central'
			else 
			if (estado == '1') return 'Esperando Sucursal'
			else 
			if (estado == '2') return 'En Sucursal'
			else 
			if (estado == '3') return 'En Ruta'
			else 
			if (estado == '4') return 'Entregado'
			else 
			if (estado == '5') return 'Cancelado'
			else 
			if (estado == '6') return 'No se pudo entregar'
			
		},
		updateOrderTimes() {
			this.orderTimes = {};  // Reiniciar el objeto orderTimes (si lo prefieres)
			for (let item of this.usuarios) {
				this.orderTimes[item.noFactura] = this.calculateTimeElapsed(item.hora);
			}
		},
		enterFullscreen() {
			const docEl = document.documentElement;
			if (docEl.requestFullscreen) {
			docEl.requestFullscreen().catch((error) => {
				console.log('Error al intentar ingresar al modo de pantalla completa:', error);
			});
			} else if (docEl.mozRequestFullScreen) { // Firefox
			docEl.mozRequestFullScreen().catch((error) => {
				console.log('Error al intentar ingresar al modo de pantalla completa:', error);
			});
			} else if (docEl.webkitRequestFullscreen) { // Chrome, Safari y Opera
			docEl.webkitRequestFullscreen().catch((error) => {
				console.log('Error al intentar ingresar al modo de pantalla completa:', error);
			});
			} else if (docEl.msRequestFullscreen) { // Internet Explorer/Edge
			docEl.msRequestFullscreen().catch((error) => {
				console.log('Error al intentar ingresar al modo de pantalla completa:', error);
			});
			}
		},
		calculateTimeElapsed(Hora) {
			var now = new Date();
			var hor1 = now.getHours();
			var min1 = now.getMinutes();
			var sec1 = now.getSeconds();

			var hor2 = parseInt(Hora.substring(0, 2));
			var min2 = parseInt(Hora.substring(3, 5));

			var diffInSec = (hor1 * 3600 + min1 * 60 + sec1) - (hor2 * 3600 + min2 * 60);

			// Si la diferencia es negativa, sumamos 24 horas (en segundos) para ajustar el cálculo
			if (diffInSec < 0) diffInSec += 24 * 3600;

			var hours = Math.floor(diffInSec / 3600);
			diffInSec %= 3600;
			var minutes = Math.floor(diffInSec / 60);
			var seconds = diffInSec % 60;

			return hours + "h: " + minutes + "m: " + seconds + "s";
		},


       listar() {
			let me = this;
			let header = { "Authorization": "Bearer " + this.$store.state.token };
			let configuracion = { headers: header };

			// Define los valores de los parámetros que deseas enviar al API
			

			// Llama al método después de un retraso de 5 segundos al cargar la página.
			setTimeout(consultarAPI(), 5000);


			// Configura el intervalo para llamar al método cada 40 segundos.
			setInterval(consultarAPI, 40000);
			
			function consultarAPI(loc,est) {
				let params = {
					Localidad: me.selectedLocalidad, // Reemplaza 'ValorLocalidad' con el valor deseado
					Estado:me.selectedEstado , // Reemplaza 2 con el valor deseado
					Facturación: null // Reemplaza 'ValorFacturación' con el valor deseado
				};
				//me.selectedLocalidad = null;
				axios.get('api/OrdenExpress/ListarComandasAdministracion/', {
					params: params, // Agrega los parámetros a la URL
					headers: header
				})
				.then(function (response) {
					const oldLength = me.usuarios.length; // Guardar la longitud anterior
					me.usuarios = response.data;
					me.loading= false;
					me.updateOrderTimes(); // <-- Actualiza el tiempo transcurrido inmediatamente después de cargar las órdenes.
					// Comprueba si la longitud de 'usuarios' ha aumentado
					if (me.usuarios.length > oldLength) {
						me.sound.play(); // Reproduce el sonido si la longitud ha aumentado
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			}
		},
		LimpiarSucursal(){
			this.selectedLocalidad = null;
			this.FiltroPorSucursal();
		},
		LimpiarEstado(){
			this.selectedEstado = null;
			this.FiltroPorSucursal();
		},
		toggleSelectedLocalidad(localidad) {
			if (this.selectedLocalidad == localidad) {
				// Si el usuario hace clic en la opción seleccionada nuevamente, deselecciónala
				this.selectedLocalidad = '';
			} else {
				// De lo contrario, establece la localidad seleccionada
				this.selectedLocalidad = localidad;
			}
			// Luego, puedes realizar cualquier otra acción que necesites aquí
			this.FiltroPorSucursal(this.selectedLocalidad);
		},
		toggleSelectedEstado(x) {
			if (this.selectedEstado == x) {
				// Si el usuario hace clic en la opción seleccionada nuevamente, deselecciónala
				this.selectedEstado = null;
			} else {
				// De lo contrario, establece la localidad seleccionada
				this.selectedEstado = x;
			}
			// Luego, puedes realizar cualquier otra acción que necesites aquí
			this.FiltroPorSucursal();
		},
		FiltroPorSucursal() {
			let me = this;
			this.loading = true;
			let header = { "Authorization": "Bearer " + this.$store.state.token };
			let configuracion = { headers: header };
			// Define los valores de los parámetros que deseas enviar al API
			let params = {
				Localidad: this.selectedLocalidad, // Reemplaza 'ValorLocalidad' con el valor deseado
				Estado: this.selectedEstado, // Reemplaza 2 con el valor deseado
				Facturación: null // Reemplaza 'ValorFacturación' con el valor deseado
			};
				axios.get('api/OrdenExpress/ListarComandasAdministracion/', {
					params: params, // Agrega los parámetros a la URL
					headers: header
				})
				.then(function (response) {
					const oldLength = me.usuarios.length; // Guardar la longitud anterior
					me.usuarios = response.data;
					me.loading= false;
					me.updateOrderTimes(); // <-- Actualiza el tiempo transcurrido inmediatamente después de cargar las órdenes.
					// Comprueba si la longitud de 'usuarios' ha aumentado
					if (me.usuarios.length > oldLength) {
						me.sound.play(); // Reproduce el sonido si la longitud ha aumentado
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			
		},
		FiltroPorEstado(Estado) {
			let me = this;
			this.loading = true;
			let header = { "Authorization": "Bearer " + this.$store.state.token };
			let configuracion = { headers: header };
				axios.get('api/OrdenExpress/FiltrarPorEstado/'+Estado, configuracion)
					.then(function (response) {
						const oldLength = me.usuarios.length; // Guardar la longitud anterior
						me.usuarios = response.data;
						me.loading= false;
						me.updateOrderTimes(); // <-- Actualiza el tiempo transcurrido inmediatamente después de cargar las órdenes.
						// Comprueba si la longitud de 'usuarios' ha aumentado
						if (me.usuarios.length > oldLength) {
							me.sound.play(); // Reproduce el sonido si la longitud ha aumentado
						}
					})
					.catch(function (error) {
						console.log(error);
					});
		},
		FiltroPorFacturacion343(Estado) {
			let me = this;
			this.loading = true;
			let header = { "Authorization": "Bearer " + this.$store.state.token };
			let configuracion = { headers: header };
				axios.get('api/OrdenExpress/ListarFiltrFacturacion/'+Estado, configuracion)
					.then(function (response) {
						const oldLength = me.usuarios.length; // Guardar la longitud anterior
						me.usuarios = response.data;
						me.loading= false;
						me.updateOrderTimes(); // <-- Actualiza el tiempo transcurrido inmediatamente después de cargar las órdenes.
						// Comprueba si la longitud de 'usuarios' ha aumentado
						if (me.usuarios.length > oldLength) {
							me.sound.play(); // Reproduce el sonido si la longitud ha aumentado
						}
					})
					.catch(function (error) {
						console.log(error);
					});
		},
		updateOrdenExpress(data) {
            axios.put('/api/OrdenExpress/ActualizarOrden', data)
                .then(response => {
                    console.log('Actualizado exitosamente');
                })
                .catch(error => {
                    console.error('Hubo un error al actualizar:', error);
                });
        },
	},
  }
</script>